"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const polished_1 = require("polished");
const _1 = require("../.");
/**
 * Single image upload. Displays current image as a thumbnail.
 */
const ImageUpload = ({ name, value, placeholder, mandatory, setValue, }) => {
    const classes = useStyles();
    return (!value
        ? react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement("input", { accept: 'image/*', className: classes.input, id: name, type: 'file', onChange: (e) => {
                    const fileReader = new FileReader();
                    const files = e.target.files;
                    const { name: fileName, type: fileType } = files[0];
                    const dataFile = files[0];
                    fileReader.readAsDataURL(files[0]);
                    fileReader.onload = () => {
                        const data = fileReader.result;
                        setValue(name, {
                            name: fileName,
                            type: fileType.split('/')[0],
                            data,
                            dataFile,
                        }, mandatory, { touched: true });
                    };
                } }),
            react_1.default.createElement("label", { htmlFor: name },
                react_1.default.createElement("div", { className: classes.upload },
                    "+ Upload ",
                    placeholder || 'image')))
        : react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement("img", { src: typeof value === 'string' && value.includes('http')
                    ? value
                    : value.data, className: classes.image, alt: 'Uploaded file' }),
            react_1.default.createElement("div", { className: classes.filename }, typeof value === 'string'
                ? value
                : value.name || value.data.split('/').pop()),
            react_1.default.createElement("button", { className: classes.delete, onClick: () => setValue(name, '', mandatory, { touched: true }) },
                "Delete ",
                placeholder || 'image')));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    root: {
        textAlign: 'center',
        padding: 20,
        backgroundColor: theme.colors.fill,
        maxWidth: 300,
        borderRadius: theme.sizes.borderRadius,
    },
    input: {
        display: 'none',
    },
    upload: {
        border: `2px dashed ${(0, polished_1.darken)(0.2, theme.colors.inputBorder)}`,
        color: (0, polished_1.darken)(0.3, theme.colors.inputBorder),
        padding: '30px 20px',
        cursor: 'pointer',
        fontSize: theme.typography.labelFontSize,
        lineHeight: 'normal',
        '&:hover': {
            backgroundColor: (0, polished_1.lighten)(0.02, theme.colors.fill),
        },
    },
    delete: {
        backgroundColor: theme.colors.accent,
        color: theme.colors.inputBg !== 'transparent' ? theme.colors.inputBg : 'white',
        fontSize: theme.typography.labelFontSize,
        lineHeight: 'normal',
        padding: '5px 8px',
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: (0, polished_1.lighten)(0.02, theme.colors.accent),
        },
    },
    image: {
        display: 'block',
        backgroundColor: 'white',
        padding: 5,
        margin: '0 auto 10px',
        maxWidth: '100%',
        boxSizing: 'border-box',
    },
    filename: Object.assign({ maxWidth: '100%', textOverflow: 'ellipsis', marginBottom: 10, fontSize: 11, color: theme.colors.inputText, lineHeight: 'normal', textAlign: 'center' }, (0, _1.maxRows)()),
}));
exports.default = (0, _1.withFormControl)(ImageUpload);
